import { FileService } from "./file.service";
import _ from "lodash";
const excludeCloneFileTypes = ['G-SHEET'];
export default class AssetService {
  static canClone(asset) {
    if(!asset){
      return false;
    }
    const share = _.get(asset, 'settings.share');
    if(!share){
      return false;
    }

    var fileType = FileService.getFileType(asset.metadata);
    if(excludeCloneFileTypes.includes(fileType)){
      return false;
    } 
    
    return true;
  }

  static getNumericValue(obj, path, defaultPath) {
    const rawValue = typeof obj === "object" ? _.get(obj, path) || _.get(obj, defaultPath) : obj;
    return rawValue != "0" ? Number(rawValue) : undefined;
  }

  static _toSnakeCase(str) {
    return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
  }

  static convertKeysToSnakeCase(obj) {
    if (obj === null || typeof obj !== "object") {
      return obj;
    }

    if (Array.isArray(obj)) {
      return obj.map((item) => this.convertKeysToSnakeCase(item));
    }

    const snakeCaseObj: Record<string, any> = {};

    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const snakeKey = this._toSnakeCase(key);
        const value = obj[key];
        snakeCaseObj[snakeKey] = this.convertKeysToSnakeCase(value);
      }
    }

    return snakeCaseObj;
  }
}
